/**
 * @module app.demo
 */

import { bindable, processContent } from 'aurelia-framework';

function fixIndents(html: string) {
    const [, indent] = html.match(/^\n*(\s*).*?$/m) || [];
    if(indent) {
        html = html.replace(new RegExp(`^${indent}`, 'gm'), '');
    }
    return html.trim();
}


@processContent(CodeExample.processContent)
export class CodeExample {

    @bindable
    protected fullWidth: boolean = false;

    protected element: Element;
    protected language: string = 'html';
    protected $code: HTMLElement;

    constructor(element: Element) {
        this.element = element;
        this.$code = this.element.querySelector<HTMLElement>('code')!;
    }

    protected attached() {
        this.$code.setAttribute('language', this.language);
    }

    protected static processContent(_compiler: any, _resources: any, el: Element, _instruction: any): boolean {
        const codeText = document.createTextNode(fixIndents(el.innerHTML));
        const code = document.createElement('code');
        code.appendChild(codeText);
        code.setAttribute('slot', 'code');
        el.appendChild(code);
        return true;
    }
}
